import { ICON_TYPES } from '../constants';

export const CheckboxUncheck = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1611_49026)">
        <path
          d="M16.625 0H4.375C3.2151 0.00138938 2.10311 0.462772 1.28294 1.28294C0.462772 2.10311 0.00138938 3.2151 0 4.375L0 16.625C0.00138938 17.7849 0.462772 18.8969 1.28294 19.7171C2.10311 20.5372 3.2151 20.9986 4.375 21H16.625C17.7849 20.9986 18.8969 20.5372 19.7171 19.7171C20.5372 18.8969 20.9986 17.7849 21 16.625V4.375C20.9986 3.2151 20.5372 2.10311 19.7171 1.28294C18.8969 0.462772 17.7849 0.00138938 16.625 0ZM19.25 16.625C19.25 17.3212 18.9734 17.9889 18.4812 18.4812C17.9889 18.9734 17.3212 19.25 16.625 19.25H4.375C3.67881 19.25 3.01113 18.9734 2.51884 18.4812C2.02656 17.9889 1.75 17.3212 1.75 16.625V4.375C1.75 3.67881 2.02656 3.01113 2.51884 2.51884C3.01113 2.02656 3.67881 1.75 4.375 1.75H16.625C17.3212 1.75 17.9889 2.02656 18.4812 2.51884C18.9734 3.01113 19.25 3.67881 19.25 4.375V16.625Z"
          fill="#43494F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1611_49026">
          <rect width="21" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

CheckboxUncheck.iconType = ICON_TYPES.CHECKBOX_UNCHECK;
